import styled from "styled-components";

export const WhitePage = styled.section`
    background-color: #fff;
    flex: 1;
`;
